import { render, staticRenderFns } from "./aiyszc.vue?vue&type=template&id=98fcc93a&scoped=true"
import script from "./aiyszc.vue?vue&type=script&lang=js"
export * from "./aiyszc.vue?vue&type=script&lang=js"
import style0 from "./aiyszc.vue?vue&type=style&index=0&id=98fcc93a&prod&lang=scss&scoped=true"
import style1 from "./aiyszc.vue?vue&type=style&index=1&id=98fcc93a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98fcc93a",
  null
  
)

export default component.exports